import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  video: {
    width: '200px',
    height: '200px',
    backgroundColor: '#eee',
    border: `1px solid ${theme.palette.primary.main}`,
  },
  error: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
  },
});

class Camera extends React.Component {
  state = {
    constraints: { audio: false, video: { width: 200, height: 200, facingMode: 'user' } },
    error: null,
  };

  componentDidMount() {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }

    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = (constraints) => {
        const getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

        if (!getUserMedia) {
          return Promise.reject(new Error('Câmera não disponível. Verifique sua câmera e a versão do seu navegador.'));
        }

        return new Promise((resolve, reject) => {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }

    const { constraints } = this.state;

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        const video = document.querySelector('video');
        video.srcObject = stream;
        video.play();
      })
      .catch((error) => {
        let { message } = error;
        if (error.name === 'NotFoundError') {
          message = 'Recurso de câmera não disponível ou não encontrado.';
        }
        if (error.name === 'NotAllowedError') {
          message = 'Acesso à câmera bloqueado. Verifique as configurações do seu navegador.';
        }
        this.setState({ error: message });
      });
  }

  takePicture() {
    if (this.state.error) {
      return null;
    }

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const video = document.querySelector('video');

    canvas.width = 200;
    canvas.height = 200;
    context.drawImage(video, 0, 0, 200, 200);

    return canvas.toDataURL().split(',')[1];
  }

  render() {
    const { classes } = this.props;
    const { error } = this.state;

    return error ? (
      <div className={classNames(classes.video, classes.error)}>
        <Typography color="textSecondary">{error}</Typography>
      </div>
    ) : (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video id="video" className={classes.video} />
    );
  }
}

Camera.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Camera);
